module.exports = __webpack_public_path__ + "media/images/undraw/reserve/firmware-420b9bd78bf8e81306954949e2db6163.png";